import { WellConfiguration } from 'src/common/interfaces/hierarchy-settings.interface';
import { HierarchyLevelType } from 'src/enums/hierarchy';
import i18n from 'src/internationalisation/i18n';
import translations from 'src/internationalisation/translation-map.json';

export const getHierarchyLevelLabel = (hierarchyLevel: string, hierarchyLabelType: string, plural = false) => {
  switch (hierarchyLevel) {
    case HierarchyLevelType.Country:
      return plural ? i18n.t(translations.countries) : i18n.t(translations.country);

    case HierarchyLevelType.Field:
      if (hierarchyLabelType === WellConfiguration.ONSHORE) {
        return plural ? i18n.t(translations.regions) : i18n.t(translations.region);
      }
      return plural ? i18n.t(translations.fields) : i18n.t(translations.field);

    case HierarchyLevelType.Site:
      if (hierarchyLabelType === WellConfiguration.ONSHORE) {
        return plural ? i18n.t(translations.pads) : i18n.t(translations.pad);
      }
      return plural ? i18n.t(translations.sites) : i18n.t(translations.site);

    case HierarchyLevelType.Well:
      return plural ? i18n.t(translations.wells) : i18n.t(translations.well);

    case HierarchyLevelType.Wellbore:
      return plural ? i18n.t(translations.wellbores) : i18n.t(translations.wellbore);

    default:
      return '';
  }
};
